// client\src\utils\fileUpload.js
import axios from 'axios';
import { toast } from 'react-toastify';
import authHeader from '../services/authHeader';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

/**
 * Uploads a file to the server and returns the file path.
 * @param {File} file - The file to upload.
 * @param {string} field - The field name to associate with the file in FormData.
 * @returns {Promise<string>} - The uploaded file path.
 */
const fileUpload = async (file, field = 'image') => {
  if (!file) {
    toast.error('কোনো ফাইল নির্বাচন করা হয়নি।', { position: 'top-right' });
    throw new Error('No file selected.');
  }

  const uploadFormData = new FormData();
  uploadFormData.append(field, file);

  try {
    const response = await axios.post(`${API_URL}/upload`, uploadFormData, {
      headers: {
        ...authHeader(),
        'Content-Type': 'multipart/form-data',
      },
    });



    if (!response?.data?.message) {
      throw new Error(response?.data?.data?.error || 'ফাইল আপলোড ব্যর্থ হয়েছে।');
    }

    toast.success('ফাইল সফলভাবে আপলোড হয়েছে!', { position: 'top-right' });


    

    return response?.data?.filePath;
  } catch (error) {
    toast.error(`ফাইল আপলোড ব্যর্থ: ${error.message}`, { position: 'top-right' });
    throw error;
  }
};

export default fileUpload;